module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/brand/document-brand-833534d0b441e71dbd44ef23b08698df.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/brand/document-brand.svg
// module id = pi1d
// module chunks = 24